import React, { useMemo, useState } from 'react';
import PostCard from './PostCard';
import { postsInSection } from './content';

export default function SectionPage({ section, navigate }) {
  const [query, setQuery] = useState('');
  const posts = useMemo(() => postsInSection(section.key), [section.key]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return posts;
    return posts.filter(
      (p) =>
        p.title.toLowerCase().includes(q) ||
        p.content.toLowerCase().includes(q)
    );
  }, [posts, query]);

  return (
    <div className="page">
      <p className="section-label">{posts.length} entries</p>
      <h1 className="section-title">{section.label}</h1>
      <div className="section-divider" />
      <p className="section-intro">{section.blurb}</p>

      <div className="controls-bar">
        <input
          type="search"
          className="search-input"
          placeholder={`Search ${section.label.toLowerCase()}…`}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label={`Search ${section.label}`}
        />
        {query && (
          <span className="controls-count">
            {filtered.length} of {posts.length}
          </span>
        )}
      </div>

      {filtered.length === 0 ? (
        <p className="empty-state">
          Nothing matches “{query}”.{' '}
          <button className="link-btn" onClick={() => setQuery('')}>
            Clear search
          </button>
        </p>
      ) : (
        <div className="posts-grid">
          {filtered.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              navigate={navigate}
              showSection={false}
            />
          ))}
        </div>
      )}
    </div>
  );
}
